import { AvoClient } from '@/lib/avo-client';

export type { BulkAction } from '@/lib/avo-client';

export const avo = new AvoClient({ enrichResponses: true });
